import styled from 'styled-components'

import {Container} from '../container/Container'

export const Overlay = styled(Container)`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background-color: ${({theme}) => theme.colors.modalOverlay};
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  pointer-events: none;
`

export const MessageContainer = styled(Container)`
  pointer-events: auto;
`
